import type { ReactNode } from 'react'

interface SectionCardProps {
  title: string
  score?: number
  children: ReactNode
}

export function SectionCard({ title, score, children }: SectionCardProps) {
  const scoreColor = score !== undefined
    ? score >= 80 ? 'text-green-600' : score >= 60 ? 'text-yellow-600' : 'text-red-600'
    : ''

  return (
    <div className="bg-white dark:bg-neutral-800 rounded-xl border border-neutral-200 dark:border-neutral-700 overflow-hidden">
      <div className="px-5 py-4 border-b border-neutral-200 dark:border-neutral-700 flex items-center justify-between">
        <h3 className="font-semibold text-neutral-900 dark:text-white">{title}</h3>
        {score !== undefined && (
          <span className={`text-lg font-bold ${scoreColor}`}>{score}/100</span>
        )}
      </div>
      <div className="p-5">{children}</div>
    </div>
  )
}
